import { render } from "./FileTable.vue?vue&type=template&id=cf71bac8&scoped=true"
import script from "./FileTable.vue?vue&type=script&lang=js"
export * from "./FileTable.vue?vue&type=script&lang=js"

import "./FileTable.vue?vue&type=style&index=0&id=cf71bac8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf71bac8"]])

export default __exports__